import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { hasAnyPermission, } from '@tymia/main-api';
import { useState, } from 'react';
import { Controller, useForm, } from 'react-hook-form';
import { api, } from '../api/Api.js';
import { Button, } from '../components/Button.js';
import { LanguageSwitcher, } from '../components/LanguageSwitcher.js';
import { Textbox, } from '../components/Textbox.js';
import { useTranslation, } from '../useTranslation.js';
import { ajvResolver, } from '../utils/ajvResolver.js';
import { logo, } from './search/logo.js';
export function Login() {
    const [isLoading, setIsLoading] = useState(false);
    const tRoot = useTranslation();
    const t = tRoot.login;
    const { handleSubmit, control, setValue, getValues, setError, } = useForm({
        defaultValues: {
            email: '',
            password: '',
            token: '',
            tan: '',
        },
        resolver: ajvResolver(api.auth.login.validateRequest, {
            locale: tRoot.locale,
        }),
    });
    const tanMode = getValues('token');
    async function onSubmit({ tan, token, ...data }) {
        try {
            setIsLoading(true);
            const result = await api.auth.login.request({
                ...data,
                ...token
                    ? {
                        token,
                        tan,
                    }
                    : {},
            });
            if (result.status === 'tan required') {
                setValue('token', result.token);
                return;
            }
            if (result.status === 'success') {
                if (hasAnyPermission(result.user.permissions, 'customer.edit.all')) {
                    window.location.href = '/user/list';
                    return;
                }
                if (hasAnyPermission(result.user.permissions, 'appointment.see.specialist-own', 'appointment.see.customer')) {
                    window.location.href = '/appointment/list';
                    return;
                }
                window.location.href = '/';
            }
            if (result.status === 'error') {
                switch (result.error) {
                    case 'need verification': {
                        return setError('email', {
                            type: 'manual',
                            message: t.needVerification,
                        });
                    }
                    case 'invalid credentials': {
                        setError('email', {
                            type: 'manual',
                            message: t.invalidCredentials,
                        });
                        setError('password', {
                            type: 'manual',
                            message: t.invalidCredentials,
                        });
                        return;
                    }
                    case 'invalid tan': {
                        return setError('tan', {
                            type: 'manual',
                            message: t.invalidTan,
                        });
                    }
                    case 'account locked': {
                        return setError('email', {
                            type: 'manual',
                            message: t.accountLocked,
                        });
                    }
                }
            }
        }
        finally {
            setIsLoading(false);
        }
    }
    return (_jsx("div", { className: "\n\t\t\th-screen\n\t\t\tflex\n\t\t\titems-start\n\t\t\tjustify-center\n\t\t\tbg-background-root\n\t\t", children: _jsxs("div", { className: "\n\t\t\t\tmt-[10%]\n\t\t\t\tp-8\n\t\t\t\tmax-w-xl\n\t\t\t\tw-full\n\t\t\t\tborder\n\t\t\t\trounded-lg\n\t\t\t\tshadow-md\n\t\t\t\tbg-background-main\n\t\t\t", children: [_jsx(LanguageSwitcher, { className: "absolute top-4 right-4" }), _jsx("div", { className: "flex justify-center", children: _jsx("a", { href: "/", className: "inline-block", children: _jsx("img", { src: logo, alt: "Tymia Logo", className: "h-20 my-7" }) }) }), _jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [!tanMode && (_jsx(Controller, { name: "email", control: control, render: ({ field, fieldState }) => (_jsx(Textbox, { label: tRoot.user.EMail, value: field.value, onChange: value => field.onChange(value), position: "external", inputMode: "email", autoComplete: "email", type: "email", reserveErrorSpace: 1, error: fieldState.error?.message })) })), !tanMode && (_jsx(Controller, { name: "password", control: control, render: ({ field, fieldState }) => (_jsx(Textbox, { label: tRoot.user.Password, value: field.value, onChange: value => field.onChange(value), position: "external", inputMode: "text", autoComplete: "current-password", type: "password", error: fieldState.error?.message, reserveErrorSpace: 1 })) })), tanMode && (_jsx(Controller, { name: "tan", control: control, render: ({ field, fieldState }) => (_jsx(Textbox, { label: t.tanRequired, value: field.value, onChange: value => field.onChange(value), position: "external", inputMode: "numeric", autoFocus: true, error: fieldState.error?.message, reserveErrorSpace: 1 })) })), _jsx(Button, { position: "external", className: "text-center", size: "lg", type: "submit", disabled: isLoading, children: t.submit }), _jsx("a", { href: "/password/reset", className: "block text-center mt-6", children: tRoot.forgotPassword.link })] })] }) }));
}
//# sourceMappingURL=Login.js.map